import { FloorplanMeasurementSystem } from '../constants/venueLayout'

const CM_PER_METER = 100
const CM_PER_FOOT = 30.48

export function cmToMeters(cm: number): number {
  return cm / CM_PER_METER
}

export function metersToCm(meters: number): number {
  return meters * CM_PER_METER
}

export function cmToFeet(cm: number): number {
  return cm / CM_PER_FOOT
}

export function feetToCm(feet: number): number {
  return feet * CM_PER_FOOT
}

function roundTo(value: number, decimals: number): number {
  const pow = 10 ** decimals
  return Math.round(value * pow) / pow
}

/** Display value for length inputs (no unit suffix). */
export function formatLengthInputValue(args: {
  cm: number
  measurementSystem?: FloorplanMeasurementSystem
  maximumFractionDigits?: number
}): string {
  const {
    cm,
    measurementSystem = FloorplanMeasurementSystem.METRIC,
    maximumFractionDigits = 2,
  } = args
  const value =
    measurementSystem === FloorplanMeasurementSystem.IMPERIAL
      ? cmToFeet(cm)
      : cmToMeters(cm)
  if (!Number.isFinite(value)) return '0'
  return String(roundTo(value, maximumFractionDigits))
}

export function formatLength(args: {
  cm: number
  measurementSystem?: FloorplanMeasurementSystem
  maximumFractionDigits?: number
}): string {
  const {
    cm,
    measurementSystem = FloorplanMeasurementSystem.METRIC,
    maximumFractionDigits = 2,
  } = args
  const value =
    measurementSystem === FloorplanMeasurementSystem.IMPERIAL
      ? cmToFeet(cm)
      : cmToMeters(cm)
  const unit =
    measurementSystem === FloorplanMeasurementSystem.IMPERIAL ? 'ft' : 'm'
  return `${roundTo(value, maximumFractionDigits)} ${unit}`
}

export function parseLengthInput(args: {
  value: number | string
  measurementSystem?: FloorplanMeasurementSystem
}): number | null {
  const { value, measurementSystem = FloorplanMeasurementSystem.METRIC } = args
  const nextValue =
    typeof value === 'number' ? value : Number.parseFloat(value.trim())
  if (!Number.isFinite(nextValue)) return null
  if (measurementSystem === FloorplanMeasurementSystem.IMPERIAL) {
    return feetToCm(nextValue)
  }
  return metersToCm(nextValue)
}
